import React from 'react';
import { Button } from '@mui/material';
import { MdOutlineColorLens } from 'react-icons/md';

const CssEditButton = ({ onClick }) => {
  return (
    <Button
      variant="contained"
      startIcon={<MdOutlineColorLens size={18} />}
      onClick={onClick}
      disableElevation
      sx={{
        position: 'fixed',
        bottom: '22px',
        left: '22px',
        zIndex: 1000,
        padding: '10px 18px 10px 16px',
        gap: '4px',
        borderRadius: '14px',
        color: 'rgba(255, 255, 255, 0.94)',
        fontFamily: "'Inter', sans-serif",
        fontSize: '13.5px',
        fontWeight: 600,
        letterSpacing: '0.01em',
        textTransform: 'none',
        backdropFilter: 'blur(18px) saturate(160%)',
        WebkitBackdropFilter: 'blur(18px) saturate(160%)',
        background:
          'radial-gradient(120% 120% at 30% 20%, rgba(255, 255, 255, 0.14), rgba(255, 255, 255, 0.04) 60%, transparent 100%), rgba(255, 255, 255, 0.07)',
        border: '1px solid rgba(255, 255, 255, 0.14)',
        boxShadow:
          'inset 0 1px 0 rgba(255, 255, 255, 0.16), inset 0 -6px 14px rgba(0, 0, 0, 0.20), 0 8px 22px rgba(0, 0, 0, 0.35)',
        transition:
          'transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1), background 0.25s ease, border-color 0.25s ease, box-shadow 0.3s ease',
        '& .MuiButton-startIcon': {
          marginRight: '6px',
          color: 'var(--primary-color, #38bdf8)',
          filter: 'drop-shadow(0 1px 2px rgba(0, 0, 0, 0.30))',
        },
        '&:hover': {
          background:
            'radial-gradient(120% 120% at 30% 20%, rgba(var(--primary-color-rgb, 14, 165, 233), 0.30), rgba(var(--primary-color-rgb, 14, 165, 233), 0.08) 60%, transparent 100%), rgba(var(--primary-color-rgb, 14, 165, 233), 0.12)',
          borderColor: 'rgba(var(--primary-color-rgb, 14, 165, 233), 0.45)',
          transform: 'translateY(-2px)',
          boxShadow:
            'inset 0 1px 0 rgba(255, 255, 255, 0.20), 0 12px 28px rgba(0, 0, 0, 0.40), 0 0 18px rgba(var(--primary-color-rgb, 14, 165, 233), 0.35)',
        },
        '&:active': {
          transform: 'translateY(-1px) scale(0.97)',
          transitionDuration: '0.12s',
        },
      }}
    >
      CSS Düzenle
    </Button>
  );
};

export default CssEditButton;
